import { User } from "../../entities";
import { isAmendment, isApproval, isBookKeyBundle, isCrewList, isFileDescriptor, isRecord, isVesselParticulars, isVoyage, } from "../types";
import logger from "../../logger";
import GatewayParsingError from './GatewayParsingError';
export const getAuthorFromGateway = (userName, app) => {
    try {
        return app.get('localCache').getUser(userName);
    }
    catch (error) {
        logger.error(`User "${userName}" is not existing. Falling back to user "system" to keep app running.`);
        return app.get('localCache').getUser('system');
    }
};
export const getAuthorRefFromGateway = (userName, app) => {
    const author = getAuthorFromGateway(userName, app);
    return User.createRef(author._id);
};
export const getAuthorRefForGateway = (userRef, app) => {
    try {
        return app.get('localCache').getUserById(userRef._id).userName;
    }
    catch (error) {
        logger.error(`User with id "${userRef._id}" is not existing. Falling back to user "system" to keep app running.`);
        return 'system';
    }
};
export function valueAsNumber(value) {
    if (value === undefined) {
        return undefined;
    }
    if (typeof value === 'string') {
        const number = Number(value);
        return Number.isNaN(number) ? value : number;
    }
    return value;
}
export function applySignature(data, signature) {
    const signInfo = signature
        ? {
            SignInfo: {
                SignatureMethod: signature.method,
                KeyInfo: {
                    KeyName: signature.keyId,
                },
            },
        }
        : {};
    let signedData;
    if (isRecord(data)) {
        signedData = { Record: { ...data, ...signInfo } };
    }
    else if (isAmendment(data)) {
        signedData = { Amendment: { ...data, ...signInfo } };
    }
    else if (isApproval(data)) {
        signedData = { Approval: { ...data, ...signInfo } };
    }
    else if (isVesselParticulars(data)) {
        signedData = { VesselParticulars: { ...data, ...signInfo } };
    }
    else if (isVoyage(data)) {
        signedData = { Voyage: { ...data, ...signInfo } };
    }
    else if (isCrewList(data)) {
        signedData = { CrewList: { ...data, ...signInfo } };
    }
    else if (isFileDescriptor(data)) {
        signedData = { FileDescriptor: { ...data, ...signInfo } };
    }
    else if (isBookKeyBundle(data)) {
        signedData = { BookKeyBundle: { ...data, ...signInfo } };
    }
    else {
        throw new GatewayParsingError('Unsupported data type for signing');
    }
    if (signature) {
        signedData.Signature = signature.value;
    }
    return signedData;
}
export function isSignedRecord(data) {
    return data.Record !== undefined;
}
//# sourceMappingURL=ParsingUtils.js.map